import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {createNotification} from "app/actions/notifications";
import {get as getSubmission} from "app/requests/admin/case-submissions";
import {create as createRecord} from "app/requests/admin/cases";
import Submission from "components/helpers/admin/case-submission";
import {valueFrom, valueFromTarget} from "lib/form";
import useAppContext from "lib/hooks/use-app-context";
import usePrompt from "lib/hooks/use-prompt";
import useQueryParams from "lib/hooks/use-query-params";
import {withoutBlankValues} from "lib/object";
import Form from "./form";

export default function AdminCasesNew() {
  const {dispatch} = useAppContext();
  const navigate = useNavigate();
  const submissionID = useQueryParams().get("case_submission_id");
  const [block, setBlock] = useState(false);
  const [record, setRecord] = useState({
    author_ids: [],
    case_submission_id: submissionID,
    categories: [],
    content: "",
    disable_comments: false,
    email_preview_text: "",
    email_subject: "",
    keywords: [],
    reviewer_ids: [],
    title: ""
  });
  const [submission, setSubmission] = useState(null);

  usePrompt({when: block});
  useEffect(() => {
    if(!submissionID) { return; }

    getSubmission(submissionID).then((data) => setSubmission(data.record));
  }, [submissionID]);

  useEffect(() => {
    if(!submission) { return; }

    // TODO: Duplicate content?
    setRecord({
      ...record,
      categories: submission.categories,
      content: submission.content,
      keywords: submission.keywords.join(", "),
      title: submission.title
    });
  }, [submission]);

  const onChange = ({target}) => {
    setBlock(true);
    setRecord({...record, [target.name]: valueFromTarget(target)});
  };
  const onSubmit = (e) => {
    e.preventDefault();

    const updates = withoutBlankValues(record);
    if(updates.keywords) {
      updates.keywords = updates.keywords.split(",").map((k) => k.trim());
    }

    setBlock(false);
    createRecord({record: updates}).then(({message, success}) => {
      if(success) {
        navigate("/admin/cases", {state: {message, type: "success"}});
      } else {
        dispatch(createNotification({content: message, type: "error"}));
      }
    });
  };
  const value = (name, defaultValue) => valueFrom({defaultValue, name, objects: [record]});

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-6">
          <h1 className="text-center">New Case</h1>
          <Form {...{onChange, onSubmit, value}} />
        </div>
        <div className="col-md-4 offset-md-2">
          <h1 className="text-center">Case Submission</h1>
          <Submission record={submission} />
        </div>
      </div>
    </div>
  );
}
